import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import { connect } from 'react-redux';
import formRules from './formRules';
import Approve from '../../components/Approve';
import ErrorComponent from '../../components/Error';
import {
  injectFormState,
  onChangeFieldText,
  onBlurFieldText,
  formValidate,
} from '../../utils/form';
import { getSettings, saveSettings } from './actions';
// translate
import messages from './messages';

class Settings extends Component {
  constructor(props) {
    super(props);

    this.reset = false;

    const attributes = {
      firstName: '',
      lastName: '',
      postcode: '',
      country: '',
      address: '',
      company: '',
      minSum: '',
    };

    this.state = Object.assign(
      {
        attributes,
        showApprove: false,
      },
      injectFormState(formRules, attributes),
    );

    this.onCloseApprove = this.onCloseApprove.bind(this);
    this.formValidate = formValidate.bind(this);
    this.onChangeFieldText = onChangeFieldText.bind(this);
    this.onBlurFieldText = onBlurFieldText.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillMount() {
    this.reset = true;

    const { data } = this.props;
    if (data === null) {
      this.fetchData();
    } else {
      this.fillAttributes(data);
    }
  }

  componentWillReceiveProps(nextProps) {
    this.reset = false;

    const { isFetching, data } = nextProps;
    if (!isFetching && data !== null) {
      this.fillAttributes(data);
    }
  }

  onCloseApprove() {
    this.setState({
      showApprove: !this.state.showApprove,
    });
  }

  onSubmit() {
    this.formValidate(this.state.attributes).then((data) => {
      if (data.status) {
        this.setState({
          showApprove: true,
        });
      }
    });
  }

  onSave() {
    this.setState({
      showApprove: false,
    });

    this.props.dispatch(saveSettings(this.state.attributes));
  }

  fetchData() {
    this.props.dispatch(getSettings());
  }

  fillAttributes(data) {
    this.setState(
      Object.assign(
        {
          attributes: {
            firstName: data.first_name || '',
            lastName: data.last_name || '',
            postcode: data.postcode || '',
            country: data.country || '',
            address: data.address || '',
            company: data.company || '',
            minSum: data.min_sum || '',
          },
        },
        injectFormState(formRules, this.state.attributes),
      ),
    );
  }

  render() {
    const { intl, isFetching, data, errorMessage, saveSuccess } = this.props;
    const { validation } = this.state.formSchema;
    const {
      firstName,
      lastName,
      postcode,
      country,
      address,
      company,
      minSum,
    } = this.state.attributes;

    if (isFetching && data === null) {
      return null;
    }

    return (
      <div>
        {this.state.showApprove &&
          <Approve onClose={this.onCloseApprove} onApproved={this.onSave} />}

        {!this.reset &&
          saveSuccess &&
          <div className="popup-form-success">
            <FormattedHTMLMessage {...messages.successText} />
          </div>}

        <form className="popup-form" method="post">

          <div>
            <label className="label" htmlFor="firstName">
              {validation.firstName.message &&
                <span className="popup-form-error">
                  {intl.formatMessage(validation.firstName.message)}
                </span>}
              <input
                type="text"
                name="firstName"
                value={firstName || ''}
                placeholder={intl.formatMessage(messages.placeholderFirstName)}
                onChange={this.onChangeFieldText}
                onBlur={this.onBlurFieldText}
              />
            </label>

            <label className="label" htmlFor="lastName">
              {validation.lastName.message &&
                <span className="popup-form-error">
                  {intl.formatMessage(validation.lastName.message)}
                </span>}
              <input
                type="text"
                name="lastName"
                value={lastName || ''}
                placeholder={intl.formatMessage(messages.placeholderLastName)}
                onChange={this.onChangeFieldText}
                onBlur={this.onBlurFieldText}
              />
            </label>

            <label className="label" htmlFor="company">
              {validation.company.message &&
                <span className="popup-form-error">
                  {intl.formatMessage(validation.company.message)}
                </span>}
              <input
                type="text"
                name="company"
                value={company || ''}
                placeholder={intl.formatMessage(messages.placeholderCompany)}
                onChange={this.onChangeFieldText}
                onBlur={this.onBlurFieldText}
              />
            </label>

            <label className="label" htmlFor="country">
              {validation.country.message &&
                <span className="popup-form-error">
                  {intl.formatMessage(validation.country.message)}
                </span>}
              <input
                type="text"
                name="country"
                value={country || ''}
                placeholder={intl.formatMessage(messages.placeholderCountry)}
                onChange={this.onChangeFieldText}
                onBlur={this.onBlurFieldText}
              />
            </label>

          </div>
          <div>

            <label className="label" htmlFor="postcode">
              {validation.postcode.message &&
                <span className="popup-form-error">
                  {intl.formatMessage(validation.postcode.message)}
                </span>}
              <input
                type="text"
                name="postcode"
                value={postcode || ''}
                placeholder={intl.formatMessage(messages.placeholderPostcode)}
                onChange={this.onChangeFieldText}
                onBlur={this.onBlurFieldText}
              />
            </label>

            <label className="label" htmlFor="address">
              {validation.address.message &&
                <span className="popup-form-error">
                  {intl.formatMessage(validation.address.message)}
                </span>}
              <textarea
                name="address"
                value={address || ''}
                placeholder={intl.formatMessage(messages.placeholderAddress)}
                onChange={this.onChangeFieldText}
                onBlur={this.onBlurFieldText}
              />
            </label>

            <p style={{ paddingBottom: '5px', textAlign: 'left' }}>
              Select the minimum amount that, once your account has enough credit, a payment will be made to you.
            </p>

            <label className="label" htmlFor="minSum">
              {validation.minSum.message &&
                <span className="popup-form-error">
                  {intl.formatMessage(validation.minSum.message)}
                </span>}
              <input
                type="text"
                name="minSum"
                value={Number(minSum) || ''}
                placeholder={intl.formatMessage(messages.placeholderMinSum)}
                onChange={this.onChangeFieldText}
                onBlur={this.onBlurFieldText}
              />
            </label>

          </div>

          <button
            className="trans"
            type="button"
            disabled={isFetching}
            onClick={this.onSubmit}
          >
            {intl.formatMessage(messages.submitButton)}
          </button>
          {errorMessage &&
            !isFetching &&
            <ErrorComponent>{errorMessage}</ErrorComponent>}
        </form>
      </div>
    );
  }
}

Settings.defaultProps = {
  data: null,
  errorMessage: false,
};

Settings.propTypes = {
  intl: intlShape.isRequired,
  dispatch: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  errorMessage: PropTypes.any,
  saveSuccess: PropTypes.bool.isRequired,
  data: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    isFetching: state.get('settings').isFetching,
    errorMessage: state.get('settings').errorMessage,
    saveSuccess: state.get('settings').saveSuccess,
    data: state.get('settings').data,
  };
}

export default connect(mapStateToProps)(injectIntl(Settings));



// WEBPACK FOOTER //
// ./src/containers/Settings/index.js